function interpolateStringToTemplate(template, params) {
  const keys = Object.keys(params);
  const values = Object.values(params);
  // eslint-disable-next-line no-new-func
  return new Function(...keys, `return \`${template}\`;`)(...values);
}

export default interpolateStringToTemplate;
